import { Folder, Identifiable } from "@planzone/dto";
import { HttpClient } from "../../adapters/httpClient";
import { FileSystem } from "../../adapters/fileSystem";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function downloadFolder(
  httpClient: HttpClient,
  folder: Identifiable<Folder>,
): Promise<Identifiable<Folder>> {
  return Promise.all(
    folder.children.map((child) =>
      child.type === "document"
        ? httpClient.download(child.uri).then(({ uri }) => ({ ...child, uri }))
        : downloadFolder(httpClient, child),
    ),
  ).then((children) => ({ ...folder, children }));
}

function createInteractor(httpClient: HttpClient, fs: FileSystem): Interactor {
  return ({ folder, saveToDisk }) =>
    present(
      downloadFolder(httpClient, folder)
        .then((downloadedFolder) => ({ folder, downloadedFolder }))
        .then((res) =>
          saveToDisk
            ? fs.writeFolderToDisk(res.downloadedFolder).then(() => res)
            : res,
        )
        .catch(() => Promise.reject({ folder, saveToDisk })),
    );
}

export type { Interactor };

export { createInteractor };
